import request from "@/utils/request";

// 重点物料报废入库 分页获取数据
export function GetPage(data) {
  return request({
    url: "/keyMaterialScrap/page",
    method: "get",
    params: data,
  });
}
export function Add(data) {
  return request({
    url: "/keyMaterialScrap/save",
    method: "post",
    data,
  });
}

// 修改数据
export function Update(data) {
  return request({
    url: "/keyMaterialScrap/update",
    method: "post",
    data,
  });
}

// 删除数据
export function Delete(id) {
  return request({
    url: `/keyMaterialScrap/delete/${id}`,
    method: "delete",
  });
}
// 重点物料 分页获取数据
export function GetKeyMaterialPage(data) {
  return request({
    url: "/keyMaterial/page",
    method: "get",
    params: data,
  });
}
export function GetKeyMaterialDetail(id) {
  return request({
    url: `/keyMaterialLog/getByKeyMaterialId/${id}`,
    method: "get",
  });
}
// 导入重点物料
export function importKeyMaterial(data) {
  return request({
    url: "/keyMaterial/import",
    method: "post",
    data,
  });
}
// 导出模板
export function GetTemplate(data) {
  return request({
    url: "/keyMaterial/template",
    method: "get",
    params: data,
    responseType: "blob",
  });
}
